import { createSlice } from '@reduxjs/toolkit'

export const QuestionPaperSlice = createSlice(
    {
        name: 'questionData',
        initialState: {
            bluePrintId: '',
            metaDataIds: {},
            editedQuestionIds: {},
            showQuestions: 'no'
        },
        reducers: {

            BluePrintId: (state, action) => {
                console.log("isBluePrintId", action.payload);
                state.bluePrintId = action.payload
            },

            MetaDataIds: (state, action) => {
                console.log("MetaDataIds", action.payload);
                state.metaDataIds = action.payload
            },

            EditedQuestionIds: (state, action) => {
                console.log("editedQuestionIds", action.payload);
                state.editedQuestionIds = action.payload
            },

            ShowQuestionsData: (state, action) => {
                console.log("ShowQuestionsData", action.payload);
                state.showQuestions = action.payload
            }
        },
    },

)


export const { BluePrintId, MetaDataIds, EditedQuestionIds, ShowQuestionsData } = QuestionPaperSlice.actions

export default QuestionPaperSlice.reducer